/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lookup_release_note_statuses-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lookup_release_note_statuses-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lookup_release_note_statuses-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lookup_release_note_statuses-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lookup_release_note_statuses.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lookup_release_note_statuses-entity-config.ts
 * Public fields: 14/14 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LookupReleaseNoteStatusesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  code: Type.String(), // code field
  name: Type.String(), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  sort_order: Type.Number(), // sort_order field
  archived: Type.Boolean(), // archived field
  color: Type.Union([Type.String(), Type.Null()]), // color field
  settable_by: Type.String(), // settable_by field
  visible_to_client: Type.Boolean(), // visible_to_client field
  resets_verification: Type.Boolean(), // resets_verification field
  is_reopen: Type.Boolean(), // is_reopen field
  is_terminal: Type.Boolean(), // is_terminal field
  created_at: Type.String({ format: "date-time" }), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateLookupReleaseNoteStatusesSchema = Type.Object({
  code: Type.String(), // code field
  name: Type.String(), // name field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  sort_order: Type.Optional(Type.Number()), // sort_order field
  archived: Type.Optional(Type.Boolean()), // archived field
  color: Type.Optional(Type.Union([Type.String(), Type.Null()])), // color field
  settable_by: Type.Optional(Type.String()), // settable_by field
  visible_to_client: Type.Optional(Type.Boolean()), // visible_to_client field
  resets_verification: Type.Optional(Type.Boolean()), // resets_verification field
  is_reopen: Type.Optional(Type.Boolean()), // is_reopen field
  is_terminal: Type.Optional(Type.Boolean()), // is_terminal field
});

export const UpdateLookupReleaseNoteStatusesSchema = Type.Object({
  code: Type.Optional(Type.String()), // code field
  name: Type.Optional(Type.String()), // name field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  sort_order: Type.Optional(Type.Number()), // sort_order field
  archived: Type.Optional(Type.Boolean()), // archived field
  color: Type.Optional(Type.Union([Type.String(), Type.Null()])), // color field
  settable_by: Type.Optional(Type.String()), // settable_by field
  visible_to_client: Type.Optional(Type.Boolean()), // visible_to_client field
  resets_verification: Type.Optional(Type.Boolean()), // resets_verification field
  is_reopen: Type.Optional(Type.Boolean()), // is_reopen field
  is_terminal: Type.Optional(Type.Boolean()), // is_terminal field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LookupReleaseNoteStatusesRow = Static<typeof LookupReleaseNoteStatusesSchema>;
export type LookupReleaseNoteStatusesInsert = Static<typeof CreateLookupReleaseNoteStatusesSchema>;
export type LookupReleaseNoteStatusesUpdate = Static<typeof UpdateLookupReleaseNoteStatusesSchema>;

// Legacy type aliases for backward compatibility
export type LookupReleaseNoteStatuses = LookupReleaseNoteStatusesRow;
export type CreateLookupReleaseNoteStatuses = LookupReleaseNoteStatusesInsert;
export type UpdateLookupReleaseNoteStatuses = Static<typeof UpdateLookupReleaseNoteStatusesSchema>;

// Field configuration metadata
export const LookupReleaseNoteStatusesFieldConfig = {
  filterable: ['id', 'code'] as const,
  sortable: ['sort_order', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'code', 'name', 'sort_order', 'archived', 'settable_by', 'visible_to_client', 'resets_verification', 'is_reopen', 'is_terminal', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LookupReleaseNoteStatusesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LookupReleaseNoteStatusesResponse {
  data: LookupReleaseNoteStatuses[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLookupReleaseNoteStatusesResponse {
  data: LookupReleaseNoteStatuses | null;
  error: Error | null;
}
